import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getVotingOrganization} from "_helpers";
import {organizationActions} from "_actions";
import _ from "lodash";

export default function (organizationId) {
    const dispatch = useDispatch();

    useEffect(() => {
        getOrganization();
    }, [organizationId]);

    const getOrganization = () => {
        const organization = getVotingOrganization();
        const orgId = _.get(organization, 'id') || organizationId;
        if(orgId) {
            dispatch(organizationActions.getOrganization(orgId));
        }
    }

    const organization = useSelector(state => state.organizations.organization);
    const loadingOrganization = useSelector(state => state.organizations.loading);
    return { organization, loadingOrganization };
}